var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"statistics-title"},[_c('div',{staticClass:"statistics-title__title accent-lg text-center"},[_vm._v("\n    "+_vm._s(_vm.title)+"\n  ")]),_vm._v(" "),_c('div',{staticClass:"statistics-title__radarok"})])
}
var staticRenderFns = []

export { render, staticRenderFns }